// @flow
import CafeteriaSubsidies from './CafeteriaSubsidies';

export default CafeteriaSubsidies;
